import LiveTrackCard from "../../components/liveTrackComponent/liveTrackCard/liveTrackCard";
import LiveTrackContent from "../../components/liveTrackComponent/liveTrackContent/liveTrackContent";
import CalendarType from "../../shared/calendarType/calendarType";
import DateRangePicker from "../../shared/dateRangePicker/dateRangePicker";
import VideoSec from "../../components/videoSec/videoSec";
import {useContext, useEffect, useState} from "react";
import AppContext from "../../contexts/appContext/app.context";
import {format, sub} from "date-fns";
import LiveTrackService from "../../services/liveTrack.service";
import Loaders from "../../shared/loaders/loaders";

let ws;
const LiveTrack = () => {
    const appCtx = useContext(AppContext);
    const [startDate, setStartDate] = useState(sub(new Date(2023, 11, 25), {days: 5}));
    const [endDate, setEndDate] = useState(new Date(2023, 11, 30));
    const [showLoader, setShowLoader] = useState(false);
    const [vehicles, setVehicles] = useState([]);
    const [vehiclePos, setVehiclePos] = useState();
    const [currentTrip, setCurrentTrip] = useState();

    // {
    //     lat: 13.028753,
    //         lng: 77.584400
    // }

    const startDateFormatted = format(new Date(startDate), 'yyyy-MM-dd');
    const endDateFormatted = format(new Date(endDate), 'yyyy-MM-dd');

    // .... get vehicles ......
    const getVehicles = async () => {
        const response = await LiveTrackService.getVehicles(startDateFormatted, endDateFormatted);
        setVehicles(response);
    }


    const handleDateChange = (date) => {
        if (date[1]) {
            setStartDate(date[0]);
            setEndDate(date[1]);
        }
    }
    useEffect(() => {
        (async () => {
                setShowLoader(true);
                await getVehicles();
                setShowLoader(false);
            }

        )()

    }, [endDate]);

    const getLiveVehicle = async () => {
        const token = await LiveTrackService.getLiveVehicles();
        ws = await LiveTrackService.intializeWebSocket(token);
        ws.onmessage = (message) => {
            // call a function to trace the location of vehicles.
            const locationPacket = JSON.parse(message.data);
            console.log(message.data);
            console.log(
                "message.data.payload",
                locationPacket["payLoad.gps_info.loc.lat"],
            );
            if (
                locationPacket["payLoad.gps_info.loc.lat"] &&
                locationPacket["payLoad.gps_info.loc.lng"]
            ) {
                let currentPos = new window.google.maps.LatLng(
                    locationPacket["payLoad.gps_info.loc.lat"],
                    locationPacket["payLoad.gps_info.loc.lng"],
                );
                // calculate direction angle in which the icon/car-icon has to move
                // var angle = window.google.maps.geometry.spherical.computeHeading(
                //     this.previousPos,
                //     currentPos,
                // );

                // const markerUrl = require(`@/assets/img/${
                //     this.selected_vehicle_live_track.type !== undefined
                //         ? this.selected_vehicle_live_track.type
                //         : "LMV"
                // }.svg`);
                // document.querySelector(`[src="${markerUrl}"]`).style.transition =
                //     "transform 2s ease-in-out";
                // document.querySelector(`[src="${markerUrl}"]`).style.transform =
                //     "rotate(" + angle + "deg)";
                //
                // this.updateInfoWindow(locationPacket);
                // this.runSnapToRoad(currentPos);
            } else {
                console.log("web socket message received", JSON.parse(message.data));
            }
        };
        console.log(token);
        console.log(ws);

    }

    const onVehicleSelect = (vehicle) => {
        let Authorization = localStorage.getItem("token") || "";
        let smlToken = localStorage.getItem("smlToken") || "";
        console.log('vehicle ', vehicle);
        ws.send(
            JSON.stringify({
                action: "subscribe",
                topic: "vehicle",
                id: vehicle.vehicleId,
                smltoken: smlToken,
                authorization: Authorization,
            }),
        );

    }

    useEffect(() => {
        getLiveVehicle()
    }, [])


    // const web = async () => {
    //     let url = `/websocket/gettoken`;
    //     const socket = new WebSocket("ws://127.0.0.1:800")
    //     const res = await httpClient({}, process.env.VUE_APP_SM_API_HOST).post(
    //         url,
    //     );
    //     let socket = await intializeWebSocket(res.data.wstoken);
    //     this.socket = socket;
    //     socket.onopen = () => {
    //         var Authorization = sessionStorage.getItem("token") || "";
    //         var smlToken = sessionStorage.getItem("smlToken") || "";
    //         this.wsTimeoutTimer();
    //         /**On socket connection subscribing to vehicle id */
    //         socket.send(
    //             JSON.stringify({
    //                 action: "subscribe",
    //                 topic: "vehicle",
    //                 id: this.selected_vehicle_live_track.vehicleId,
    //                 smltoken: smlToken,
    //                 authorization: Authorization,
    //             }),
    //         );
    //     };
    //     socket.onerror = (err) => {
    //         console.log("web socket error", err);
    //     };
    //
    //     socket.onmessage = (message) => {
    //         // call a function to trace the location of vehicles.
    //         const locationPacket = JSON.parse(message.data);
    //         console.log(
    //             "message.data.payload",
    //             locationPacket["payLoad.gps_info.loc.lat"],
    //         );
    //         if (
    //             locationPacket["payLoad.gps_info.loc.lat"] &&
    //             locationPacket["payLoad.gps_info.loc.lng"]
    //         ) {
    //             let currentPos = new google.maps.LatLng(
    //                 locationPacket["payLoad.gps_info.loc.lat"],
    //                 locationPacket["payLoad.gps_info.loc.lng"],
    //             );
    //              // calculate direction angle in which the icon/car-icon has to move
    //             var angle = google.maps.geometry.spherical.computeHeading(
    //               this.previousPos,
    //               currentPos,
    //             );
    //
    //             const markerUrl = require(`@/assets/img/${
    //               this.selected_vehicle_live_track.type !== undefined
    //                 ? this.selected_vehicle_live_track.type
    //                 : "LMV"
    //             }.svg`);
    //             document.querySelector(`[src="${markerUrl}"]`).style.transition =
    //               "transform 2s ease-in-out";
    //             document.querySelector(`[src="${markerUrl}"]`).style.transform =
    //               "rotate(" + angle + "deg)";
    //
    //             this.updateInfoWindow(locationPacket);
    //             this.runSnapToRoad(currentPos);
    //           } else {
    //             console.log("web socket message received", JSON.parse(message.data));
    //           }
    //         };
    //
    //         socket.onclose = () => {
    //           console.log("connection closed!");
    //         };
    //       }


    return (
        <>
            <div className={'content-section page-fade-in'}>

                <div className=" round-corner-8 padding-tb-20 flex hr-right border-bottom margin-b-30">
                    <DateRangePicker startDate={startDate}
                                     endDate={endDate}
                                     selectRange={true}
                                     onDateChange={handleDateChange}
                                     classes={'date width-300 item-height-40'}/>
                    <CalendarType/>
                </div>

                {/*...... live track cards .....*/}
                <div className="margin-b-30 padding-t-30"><LiveTrackCard/></div>


                {/*....... video section ......*/}
                {/*{currentTrip &&*/}
                {/*    <div className="margin-b-40">*/}
                {/*        <div className="section-title margin-b-20">Critical Alert Videos</div>*/}
                {/*        <VideoSec/>*/}
                {/*    </div>*/}
                {/*}*/}

                {/*......live track details ........*/}
                <div className=""><LiveTrackContent vehiclePos={vehiclePos} vehicles={vehicles}
                                                    handleVehicleSelect={onVehicleSelect}/></div>
            </div>

            {showLoader &&
                <div className="loader-box blue-loader">
                    <Loaders/>
                </div>
            }

        </>
    )

}

export default LiveTrack;
